import { Card } from "components/card-carousel/types/card-carousel-types";

type StandardCardProps = {
	card: Card;
};

const StandardCard = ({ card }: StandardCardProps) => {
	return (
		<div
			className="carousel-card"
			onClick={() => {
				window.location.href = card.link;
			}}
			role="button"
			tabIndex={0}
			onKeyUp={(event): void => {
				const allowedKeys = new Set(["Enter", "Space"]);
				if (!allowedKeys.has(event.code)) return;
				event.preventDefault();
				window.location.href = card.link;
			}}
			data-a-evt="Link Click"
			data-a-comp="Card Carousel"
			data-a-name={card.title}
			data-a-linktype="Featured"
		>
			<div className="carousel-card-category t-label-xs-heavy">{card.tagCategory}</div>
			<div className="carousel-card-wrapper-title">
				<div className="carousel-card-title t-heading-md">{card.title}</div>
			</div>
			{card.date && <div className="carousel-card-date t-body-xxs">{card.date}</div>}

			<div className="carousel-card-wrapper">
				{card.img ? (
					<div className="carousel-card-img">
						<img alt={card.title} src={card.img}></img>
					</div>
				) : (
					<div className="carousel-card-description t-body-xs">{card.description}</div>
				)}
			</div>
		</div>
	);
};

export default StandardCard;
